import { ConfirmItemButton } from '@/components/buttons/ConfirmItemButton';
import { CustomTableHeadCell } from '@/components/tables/customCells';
import { errorToast } from '@/toast';
import AutoAwesome from '@mui/icons-material/AutoAwesome';
import { Box, Checkbox } from '@mui/material';
import { MUIDataTableColumnOptions } from 'mui-datatables';
import { FC, useCallback } from 'react';

type CustomTableHeadCellParams = Parameters<
    NonNullable<MUIDataTableColumnOptions['customHeadRender']>
>;

type SelectionHeaderProps = {
    columnMeta: CustomTableHeadCellParams[0];
    handleToggleColumn: CustomTableHeadCellParams[1];
    sortOrder: CustomTableHeadCellParams[2];
    hasItems: boolean;
    isLoading?: boolean;
    isDisabled: boolean;
    isSubmitting?: boolean;
    isSortable?: boolean;
    numSelected: number;
    summaryString: string | undefined;
    onApply: () => Promise<void>;
    selectableCount?: number;
    onSelectAll?: () => void;
};

export const SelectionHeader: FC<SelectionHeaderProps> = (props: SelectionHeaderProps) => {
    const {
        columnMeta,
        handleToggleColumn,
        sortOrder,
        hasItems,
        isLoading,
        isDisabled,
        isSubmitting,
        isSortable,
        numSelected,
        summaryString,
        onApply,
        selectableCount,
        onSelectAll,
    } = props;

    const onClick = useCallback(() => {
        onApply().catch((error: Error) => {
            errorToast(error.message);
        });
    }, [onApply]);

    const showSelectAll =
        onSelectAll !== undefined && selectableCount !== undefined && selectableCount > 0;

    return (
        <CustomTableHeadCell
            key={columnMeta.name}
            columnMeta={{ ...columnMeta }}
            handleToggleColumn={handleToggleColumn}
            sortOrder={sortOrder}
            isSortable={isSortable}
            highlight={hasItems}
            loadingBar={isLoading}
        >
            {hasItems && !isLoading && (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <ConfirmItemButton
                        startIcon={<AutoAwesome />}
                        tooltip={!isDisabled ? summaryString : ''}
                        color='primary'
                        size='small'
                        variant='contained'
                        disabled={isDisabled}
                        preventSpan
                        sx={{
                            textTransform: 'none',
                            borderRadius: 2,
                            whiteSpace: 'nowrap',
                        }}
                        onClick={onClick}
                    >
                        {`Apply${numSelected > 0 ? ` ${numSelected}` : ''}`}
                    </ConfirmItemButton>
                    {showSelectAll && (
                        <Checkbox
                            size='small'
                            disabled={isSubmitting}
                            checked={numSelected > 0 && numSelected === selectableCount}
                            indeterminate={numSelected > 0 && numSelected < selectableCount}
                            onChange={onSelectAll}
                            onClick={(event) => {
                                event.stopPropagation();
                            }}
                        />
                    )}
                </Box>
            )}
        </CustomTableHeadCell>
    );
};
